var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-editor"},[_c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig},on:{"ready":_vm.onReady,"blur":_vm.onBlur},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }